import axios from 'axios';
import { PencilLine } from '@phosphor-icons/react';
import React, { useState, useMemo } from 'react'
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'reactstrap';
import { Label } from 'reactstrap'
import { environment } from '../../env';
import { successModalToggle, getCityAction, loaderAction, getFloorTypeAction } from '../../redux/actions/Index';
import ErrorComponents from '../errorComponents/ErrorComponents';
import { useEffect } from 'react';
import moment from 'moment';
import SuccessPopups from '../Popups/SuccessPopups';
import { useNavigate } from 'react-router-dom';

function CustomBillModal({ getCustomBill }, ...props) {
    const navigate = useNavigate()
    const preventNegativeValues = (e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
    const [btndis, setBtndis] = useState(false)
    const [modal, setModal] = useState(false);
    const projectList = useSelector((state) => state?.ModalReducer?.projectList);
    const buildingList = useSelector((state) => state?.ModalReducer?.buildingList);
    const [filterBuilding, setFilterBuilding] = useState([]);
    const preventNegativeValuesspi = (e) => ["+", "-", "!", "@", "#", "$", "%", "^", "&", "*", "=", "/", "_"].includes(e.key) && e.preventDefault()
    const dispatch = useDispatch();
    const toggle = () => { setModal(!modal) }
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
        formState: { errors },
    } = useForm();
    let selectProject = watch('project')
    const onSubmit = async (data) => {
        const customBillPayload = new FormData();
        customBillPayload.append('tenant_name', data.tenant_name)
        customBillPayload.append('project', data.project)
        customBillPayload.append('building', data.building)
        customBillPayload.append('tenant_address', data.tenant_address)
        customBillPayload.append('gst', data.gst)
        customBillPayload.append('description', data.description)
        customBillPayload.append('hsn', data.hsn)
        customBillPayload.append('quantity', data.quantity)
        customBillPayload.append('rate', data.rate)
        customBillPayload.append('date', data.date)
        customBillPayload.append('unit', data.unit)
        try {
            await axios.post(`${environment.baseUrl}custom-bill`, customBillPayload).then((form) => {
                if (form.data.code === 200) {
                    dispatch(loaderAction(false));
                    toggle();
                    reset();
                    setBtndis(false)
                    getCustomBill();
                    navigate('/CustomBill/1', { state: { data: data } })
                }
                else {
                    dispatch(loaderAction(false))
                    setBtndis(false)
                    console.log(err);
                }
            })
        } catch (error) {
            console.log(error);
        }
    }
    const CancelButton = () => {
        toggle();
        reset();
    }
    useEffect(() => {
        setValue("date", moment().format('DD/MM/YYYY'))
    }, [])

    useEffect(() => {
        reset({
            "tenant_name": props?.data?.tenant_name,
            "project": props?.data?.project,
            "building": props?.data?.building,
            "tenant_address": props?.data?.tenant_address,
            "gst": props?.data?.gst,
            "description": props?.data?.description,
            "hsn": props?.data?.hsn,
            "quantity": props?.data?.quantity,
            "rate": props?.data?.rate,
            "date": moment(props?.data?.created_at).format('YYYY-MM-DD'),
            "unit": props?.data?.unit,
        })
        setValue("date", moment().format('DD/MM/YYYY'))
    }, [])
    useMemo(() => {
        const bulidingFilter = buildingList?.filter((filterData) =>
            filterData.project.id == selectProject)
        setFilterBuilding(bulidingFilter)
    }, [selectProject])
    return (
        <>
            <SuccessPopups />
            <Button
                onClick={toggle}
                className="border-radius-7  d-flex align-items-center buttons  py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5 mb-5"
            >
                <span className="fs-3 d-flex gap-3 title-font-600 px-3">
                    Custom Bill
                </span>
            </Button>
            <Modal className='border-0' isOpen={modal} toggle={props.toggle} size="xl" centered>
                <ModalHeader className='bg-base-color ' ><span className='title-font-700 fs-36 text-base-white'>Custom Bill</span></ModalHeader>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <ModalBody className='bg-background-color px-5'>
                        <div className="row">
                            <div className='col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0'>
                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                    Select Project Name
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <select
                                        id="project"
                                        name="project"
                                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                        {...register("project", { required: true })}
                                    >
                                        <option value="">Select Project</option>
                                        {projectList?.map((project, i) => {
                                            return <option value={project.id} key={i}>{project.name}</option>;
                                        })}
                                    </select>
                                </div>
                                {errors.project && (
                                    <ErrorComponents error={"Project name is required *"} />
                                )}
                                <br />
                            </div>
                            <div className='col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0'>
                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                    Select Building
                                </Label>
                                <br />
                                <div className='mt-1  d-flex gap-3'>
                                    <select id="building" name="building" className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                        {...register("building", { required: true })}
                                    >
                                        <option value="">Select Building</option>
                                        {filterBuilding?.map((building, i) => {
                                            return <option value={building.id} key={i}>{building.building_no}</option>
                                        })

                                        }
                                    </select>
                                </div>
                                {errors.building && <ErrorComponents error={'Building No is required *'} />}
                                <br />
                            </div>
                            <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    Tenant Name
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <input
                                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                        type="text"
                                        placeholder="Enter Tenant Name..."
                                        {...register("tenant_name", { required: true })}
                                    />
                                </div>
                                {errors.tenant_name && (
                                    <ErrorComponents error={"Tenant Name is required *"} />
                                )}
                                <br />
                            </div>
                            <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    Tenant Address
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <input
                                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                        type='text'
                                        placeholder="Enter Tenant Address..."
                                        {...register("tenant_address", { required: true })}
                                    />
                                </div>
                                {errors.tenant_address && (
                                    <ErrorComponents error={"Tenant Address is required *"} />
                                )}
                                <br />
                            </div>
                            <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color form-label">
                                    GST Number
                                </Label>
                                <br />
                                <div className="mt-1 d-flex gap-3">
                                    <input
                                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input text-uppercase"
                                        type="text"
                                        maxLength={15}
                                        min={0}
                                        onKeyDown={preventNegativeValuesspi}
                                        autoComplete="off"
                                        placeholder="GST Number..."
                                        {...register("gst", { onChange: (e) => { e.target.value = e.target.value.toUpperCase() } })}
                                    />
                                </div>
                                {errors.gst && (
                                    <ErrorComponents error={"GST number is required *"} />
                                )}
                                <br />
                            </div>
                            <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    Description of Services
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <input
                                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                        type="text"
                                        placeholder="Enter Description..."
                                        {...register("description", { required: true })}
                                    />
                                </div>
                                {errors.description && (
                                    <ErrorComponents error={"Description is required *"} />
                                )}
                                <br />
                            </div>
                            <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    HSN/SAC
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <input
                                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                        type='number'
                                        min={0}
                                        onKeyDown={preventNegativeValues}
                                        placeholder="Enter HSN/SAC..."
                                        {...register("hsn", { required: true })}
                                    />
                                </div>
                                {errors.hsn && (
                                    <ErrorComponents error={"HSN/SAC is required *"} />
                                )}
                                <br />
                            </div>
                            <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    Quantity
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <input
                                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                        type='number'
                                        min={0}
                                        onKeyDown={preventNegativeValues}
                                        placeholder="Enter Quantity..."
                                        {...register("quantity", { required: true })}
                                    />
                                </div>
                                {errors.quantity && (
                                    <ErrorComponents error={"GSTIN/UIN is required *"} />
                                )}
                                <br />
                            </div>
                            <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    Rate
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <input
                                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                        type='number'
                                        min={0}
                                        onKeyDown={preventNegativeValues}
                                        placeholder="Enter Rate..."
                                        {...register("rate", { required: true })}
                                    />
                                </div>
                                {errors.rate && (
                                    <ErrorComponents error={"Rate is required *"} />
                                )}
                                <br />
                            </div>
                            <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    Unit
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <input
                                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                        type="text"
                                        placeholder="Enter Unit..."
                                        {...register("unit", { required: true })}
                                    />
                                </div>
                                {errors.unit && (
                                    <ErrorComponents error={"Unit is required *"} />
                                )}
                                <br />
                            </div>
                            <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    Date
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <input
                                        className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                        type="date"
                                        {...register("date", { required: true })}
                                    />
                                </div>
                                {errors.date && (
                                    <ErrorComponents error={"Date is required *"} />
                                )}
                                <br />
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button type='button' className='border-radius-7 p-3 d-flex align-items-center buttons-outline' onClick={CancelButton}><span className='fs-4 d-flex gap-3 title-font-600 px-3'>Cancel</span></Button>
                        <Button className='border-radius-7 p-3 d-flex align-items-center buttons' type='submit'><span className='fs-4 d-flex gap-3 title-font-600 px-3'>Create</span></Button>
                    </ModalFooter>
                </Form>
            </Modal>
        </>
    )
};


export default CustomBillModal